import React from 'react';
import { CheckCircleIcon, CircleStackIcon } from '@heroicons/react/24/outline';

const EmbeddingHealth: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-[var(--brand-border)] bg-[var(--brand-surface-primary)] p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
            <CheckCircleIcon className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-[var(--brand-text-primary)]">
              EdgeLex-Native Document Retrieval
            </h3>
            <p className="text-sm text-[var(--brand-text-secondary)] mt-1">
              The legacy embedding control plane has been removed from the DMS settings surface. Document retrieval now
              flows through EdgeLex ingestion, derived text, Weaviate-backed runtime retrieval, EdgeCite validation, and
              LangGraph governed answer synthesis.
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-[var(--brand-border)] bg-[var(--brand-surface-primary)] p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
            <CircleStackIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-[var(--brand-text-primary)]">
              Current Operator Checks
            </h3>
            <p className="text-sm text-[var(--brand-text-secondary)] mt-1">
              Use the DMS document intelligence panel and EdgeLex Logger to inspect ingestion, classification,
              retrieval, and citation validation events for newly uploaded documents.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmbeddingHealth;
